











import { Component, Vue } from 'vue-property-decorator';

import StInput2 from '@/components/basic/StInput2.vue';
import { notifyError, notifySuccess } from '@/utlitities/notifications';
import { ResetPasswordModel } from '@/services/api/nswag/stapiclient_generated';
import { stAuthenticationApi } from '@/services/st-api';

@Component({
  components: {
    StInput2,
  },
})
export default class ResetPassword extends Vue {
  loading: boolean = false;
  resetPasswordModel: ResetPasswordModel = new ResetPasswordModel();

  async created() {
    if (!this.$route.params.id || !this.$route.query.token) {
      notifyError('Der Reset-Link ist ungültig.');
    }
    this.resetPasswordModel.id = this.$route.params.id as string;
    this.resetPasswordModel.token = this.$route.query.token as string;
  }

  async submit() {
    this.loading = true;
    try {
      await stAuthenticationApi.resetPassword(this.resetPasswordModel);
      notifySuccess('Das Passwort wurde geändert, Sie werden jetzt automatisch angemeldet.');
      await this.$router.push('/');
    } finally {
      this.loading = false;
    }
  }
}
